import React from 'react';

export function CommunityBoard(props) {
  return <div></div>;
}
